// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"SpecialRequests_toolbar__3pzg7","table":"SpecialRequests_table__4OE_c","agora":"SpecialRequests_agora__1UyzJ"};